import { createStyles, makeStyles } from "@material-ui/core";
import { theme } from "config/theme";

export const useJobInfoStyles = makeStyles(() =>
  createStyles({
    title: {
      paddingBottom: 20,
      textTransform: "capitalize",
    },
    step: {
      fontSize: 20,
      fontWeight: 900,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#399ebf",
      textTransform: "capitalize",
      paddingBottom: 10,
      [theme.breakpoints.down("xs")]: {
        marginLeft: 10,
      },
    },
    boldText: {
      fontWeight: "bold",
    },
    deliveryDateInfo: {
      fontSize: 16,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      [theme.breakpoints.down("xs")]: {
        margin: "-39px 12px 5px 6px",
      },
    },
    subTitle: {
      fontSize: 18,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#787878",
      [theme.breakpoints.down("xs")]: {
        top: -34,
        position: "relative",
        left: "12px",
        fontSize: "14px",
      },
    },
    container: {
      display: "flex",
      flexDirection: "column",
      padding: "12px",
      justifyContent: "space-between",
      height: "80vh",
      overflow: "auto",
      marginTop: -36,
      maxWidth: "max-content",
    },
    root: {
      height: "70vh",
      alignItems: "center",
      justifyContent: "flex-end",
      marginTop: "16px",
      [theme.breakpoints.down("xs")]: {
        overflowY: "auto",
        overflowX: "none",
        width: "100%",
        padding: "12px",
      },
    },
    vehicleContainer: {
      position: "relative",
      [theme.breakpoints.down("xs")]: {
        display: "contents",
      },
    },
    formVehicle: {
      [theme.breakpoints.down("xs")]: {
        marginLeft: "27px",
        marginRight: "49px",
        marginTop: "2px",
      },
    },

    vehicleLabel: {
      color: "#707070",
      [theme.breakpoints.down("xs")]: {
        marginLeft: "30px",
      },
    },

    radioForm: {
      [theme.breakpoints.down("xs")]: {
        flexWrap: "nowrap",
        "& .MuiTypography-body1": {
          fontSize: "12px",
          marginLeft: -4,
        },
      },
    },
    radioGroup: {
      fontSize: "10px",
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        top: -60,
        left: "12px",
      },
    },

    globalButton: {
      position: "relative",
      right: "15px",
      marginTop: "40px",
      display: "flex",
      bottom: "28px",
      [theme.breakpoints.down("xs")]: {
        marginTop: "8px",
        padding: "10px",
        width: "100%",
      },
    },
    button: {
      width: "160px",
      marginLeft: "20px",
      display: "flex",
      [theme.breakpoints.down("xs")]: {
        width: "inherit",
        marginLeft: "27px",
        marginRight: "4px",
      },
    },
    adresse: {
      [theme.breakpoints.down("xs")]: {
        marginTop: -92,
      },
    },
    date: {
      [theme.breakpoints.down("xs")]: {
        marginTop: "-4px",
        marginLeft: "3px",
        marginRight: "10px",
      },
    },
    fieldDate: {
      [theme.breakpoints.down("xs")]: {},
    },
    creneau: {
      paddingBottom: "0px !important",
      [theme.breakpoints.down("xs")]: {
        margin: "24px 10px 12px 2px",
      },
    },
    formCreneau: {
      [theme.breakpoints.down("xs")]: {
        width: "86vw",
        left: 20,
      },
    },
    fieldset: {
      margin: "0px 0px 10px 0px !important",
    },
  })
);

export const useJobDetailsStyles = makeStyles(() =>
  createStyles({
    root: {
      paddingTop: "28px",
      " @media(max-width: 1279px)": {
        paddingLeft: "40px",
      },
    },
    warningDiv: {
      width: "24px",
      height: "24px",
      opacity: 0.85,
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      position: "relative",
      left: "5px",
      top: "25px",
    },
    orderStyle: {
      fontSize: "14px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    receiverStyle: {
      fontSize: "14px",
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#707070",
      display: "flex",
      justifyContent: "space-between",
    },
    address: {
      fontSize: "14px",
      fontWeight: 300,
      fontStretch: "normal",
      fontStyle: "italic",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#707070",
    },
  })
);
